import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-salir',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-salir.component.html',
  styleUrl: './modal-salir.component.css',
})
export class ModalSalirComponent {
  @Input() mostrarModal: boolean = false;
  @Output() confirmar = new EventEmitter<void>();
  @Output() cancelar = new EventEmitter<void>();

  onConfirm(): void {
    this.confirmar.emit();
  }

  onCancel(): void {
    this.cancelar.emit();
  }
}
